import { Modal as BModal } from 'bootstrap'

export interface Modal {
    show(): void
    hide(): void
}

const modalCache: {key: Element, value: BModal}[] = []

export function useModal(el: Element | null) {
    if (el == null) return null

    if (!modalCache.find(x => x.key === el)) {
        const modal = new BModal(el!)
        modalCache.push({
            key: el,
            value: modal
        })
    }

    return {
        show() {
            modalCache.find(x => x.key === el)?.value?.show()
        },
        hide() {
            modalCache.find(x => x.key === el)?.value?.hide()
        },
        isOpen() {
            return (<HTMLElement>el)?.style.display !== 'none'
        }
    } as Modal
}
